import React, { FC } from 'react';
import { Stack } from '@mui/material';

import GeneralStatus from '@/components/statuses/GeneralStatus/GeneralStatus';

interface StatusDisplayProps {
  value: string;
}

const StatusDisplay: FC<StatusDisplayProps> = ({ value }) => (
  <Stack
    direction="row"
    sx={{
      '& .StatusChipIndicator-general:not(:hover)': {
        bgcolor: 'transparent'
      }
    }}
  >
    <GeneralStatus value={value} />
  </Stack>
);

export default StatusDisplay;
